module.exports = __webpack_public_path__ + "img/timeline_miscevent-5.8b145372.jpg";